module.exports = __webpack_public_path__ + "img/detail.438bd79a.png";